module.exports = __webpack_public_path__ + "static/media/overmij.dd59a0fb.png";